
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("4DFwx"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("4DFwx", function(module, exports) {

let $360b03b6a93a98e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $360b03b6a93a98e3$var$load("cRtGo"),
    $360b03b6a93a98e3$var$load("hCiBy"),
    $360b03b6a93a98e3$var$load("3q2Ng"),
    $360b03b6a93a98e3$var$load("jRpDi"),
    $360b03b6a93a98e3$var$load("55OBD"),
    $360b03b6a93a98e3$var$load("dYtBN"),
    $360b03b6a93a98e3$var$load("kNV5Y"),
    $360b03b6a93a98e3$var$load("jUBhK"),
    $360b03b6a93a98e3$var$load("ddJJa"),
    $360b03b6a93a98e3$var$load("27glK"),
    $360b03b6a93a98e3$var$load("bvY53"),
    $360b03b6a93a98e3$var$load("hnbN4"),
    $360b03b6a93a98e3$var$load("7jSfd"),
    $360b03b6a93a98e3$var$load("4HZlX"),
    $360b03b6a93a98e3$var$load("kDqHr"),
    $360b03b6a93a98e3$var$load("gT8XU"),
    $360b03b6a93a98e3$var$load("3GuOt"),
    $360b03b6a93a98e3$var$load("3Mspc"),
    $360b03b6a93a98e3$var$load("9aQIt"),
    $360b03b6a93a98e3$var$load("XZauT"),
    $360b03b6a93a98e3$var$load("4S1SF"),
    $360b03b6a93a98e3$var$load("lm9Lt"),
    $360b03b6a93a98e3$var$load("9wPDc"),
    $360b03b6a93a98e3$var$load("1MWOL"),
    $360b03b6a93a98e3$var$load("6fQco"),
    $360b03b6a93a98e3$var$load("aOY32"),
    $360b03b6a93a98e3$var$load("3MYQs"),
    $360b03b6a93a98e3$var$load("6SWFK"),
    $360b03b6a93a98e3$var$load("5zapo"),
    $360b03b6a93a98e3$var$load("jiFtb"),
    $360b03b6a93a98e3$var$load("6wr18"),
    $360b03b6a93a98e3$var$load("9atVd"),
    $360b03b6a93a98e3$var$load("dek7I"),
    $360b03b6a93a98e3$var$load("6iz6l"),
    $360b03b6a93a98e3$var$load("4SCW2"),
    $360b03b6a93a98e3$var$load("fdKpi"),
    $360b03b6a93a98e3$var$load("ffEVr"),
    $360b03b6a93a98e3$var$load("hhss7"),
    $360b03b6a93a98e3$var$load("5JkDi"),
    $360b03b6a93a98e3$var$load("eTYdV"),
    $360b03b6a93a98e3$var$load("Wowvf"),
    $360b03b6a93a98e3$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("9cyue"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("9cyue", function(module, exports) {

let $6b2ffc638e5aab0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b2ffc638e5aab0c$var$load("cRtGo"),
    $6b2ffc638e5aab0c$var$load("hCiBy"),
    $6b2ffc638e5aab0c$var$load("6wr18"),
    $6b2ffc638e5aab0c$var$load("3j4Bc"),
    $6b2ffc638e5aab0c$var$load("2tIxk"),
    $6b2ffc638e5aab0c$var$load("dLq4a"),
    $6b2ffc638e5aab0c$var$load("27glK"),
    $6b2ffc638e5aab0c$var$load("bvY53"),
    $6b2ffc638e5aab0c$var$load("ffEVr"),
    $6b2ffc638e5aab0c$var$load("hjqVy"),
    $6b2ffc638e5aab0c$var$load("lPWNR"),
    $6b2ffc638e5aab0c$var$load("eTYdV"),
    $6b2ffc638e5aab0c$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("cOnYe"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("cOnYe", function(module, exports) {

let $953cbf94dbfc9d12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $953cbf94dbfc9d12$var$load("141M2"),
    $953cbf94dbfc9d12$var$load("c0JsV"),
    $953cbf94dbfc9d12$var$load("h3ABO"),
    $953cbf94dbfc9d12$var$load("P9KwW"),
    $953cbf94dbfc9d12$var$load("g2Bu8"),
    $953cbf94dbfc9d12$var$load("5o4Kn"),
    $953cbf94dbfc9d12$var$load("6rS39"),
    $953cbf94dbfc9d12$var$load("iEUHW"),
    $953cbf94dbfc9d12$var$load("kbwlB"),
    $953cbf94dbfc9d12$var$load("2YffH"),
    $953cbf94dbfc9d12$var$load("9XOeB"),
    $953cbf94dbfc9d12$var$load("xu7ej"),
    $953cbf94dbfc9d12$var$load("iQ4FP"),
    $953cbf94dbfc9d12$var$load("89s90"),
    $953cbf94dbfc9d12$var$load("grTPo"),
    $953cbf94dbfc9d12$var$load("73TmC"),
    $953cbf94dbfc9d12$var$load("k3Yy8"),
    $953cbf94dbfc9d12$var$load("jEvZI"),
    $953cbf94dbfc9d12$var$load("im1VN"),
    $953cbf94dbfc9d12$var$load("eD3Si"),
    $953cbf94dbfc9d12$var$load("9anPW"),
    $953cbf94dbfc9d12$var$load("84qtb"),
    $953cbf94dbfc9d12$var$load("iJxH8"),
    $953cbf94dbfc9d12$var$load("aapZc"),
    $953cbf94dbfc9d12$var$load("gnDXu"),
    $953cbf94dbfc9d12$var$load("5XC9j"),
    $953cbf94dbfc9d12$var$load("iqTGf"),
    $953cbf94dbfc9d12$var$load("3q2Ng"),
    $953cbf94dbfc9d12$var$load("jRpDi"),
    $953cbf94dbfc9d12$var$load("jUBhK"),
    $953cbf94dbfc9d12$var$load("ddJJa"),
    $953cbf94dbfc9d12$var$load("hnbN4"),
    $953cbf94dbfc9d12$var$load("lTK3c"),
    $953cbf94dbfc9d12$var$load("1WXdc"),
    $953cbf94dbfc9d12$var$load("b2FtX"),
    $953cbf94dbfc9d12$var$load("lmLaO"),
    $953cbf94dbfc9d12$var$load("f6ERn"),
    $953cbf94dbfc9d12$var$load("6iz6l"),
    $953cbf94dbfc9d12$var$load("4SCW2"),
    $953cbf94dbfc9d12$var$load("breTf"),
    $953cbf94dbfc9d12$var$load("lYmf7"),
    $953cbf94dbfc9d12$var$load("5HAR6"),
    $953cbf94dbfc9d12$var$load("arLFU"),
    $953cbf94dbfc9d12$var$load("cRtGo"),
    $953cbf94dbfc9d12$var$load("6wr18"),
    $953cbf94dbfc9d12$var$load("jvHRs"),
    $953cbf94dbfc9d12$var$load("2tIxk"),
    $953cbf94dbfc9d12$var$load("dLq4a"),
    $953cbf94dbfc9d12$var$load("27glK"),
    $953cbf94dbfc9d12$var$load("bvY53"),
    $953cbf94dbfc9d12$var$load("5NQgH"),
    $953cbf94dbfc9d12$var$load("hhss7"),
    $953cbf94dbfc9d12$var$load("Wowvf"),
    $953cbf94dbfc9d12$var$load("ffEVr"),
    $953cbf94dbfc9d12$var$load("hjqVy"),
    $953cbf94dbfc9d12$var$load("lPWNR"),
    $953cbf94dbfc9d12$var$load("jnVKv"),
    $953cbf94dbfc9d12$var$load("hCiBy"),
    $953cbf94dbfc9d12$var$load("7EorR"),
    $953cbf94dbfc9d12$var$load("bgHzk"),
    $953cbf94dbfc9d12$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.c7563f15.js.map
